// These values correspond with the identifier types we set in Sales for
// a package interest event
// See: https://github.com/vendasta/sales/blob/d642b064314a33c963ddbb9f78ab41b8b8e1c575/internal/legacy/events.go#L13-L16
export enum InterestOrigin {
  INTEREST_ORIGIN_VBC_USER = 'VBCUserID',
  INTEREST_ORIGIN_EMAIL = 'UserEmail',
}
